/* @flow */

import { SWITCH_EVENTS, DISMISS_FLASH_MESSAGE } from './actions';

const initialState = { events: '', flashMessage: true };

export default (state: AnyMap = initialState, action: { type: string, payload: Object }): AnyMap => {
  switch (action.type) {
    case SWITCH_EVENTS:
      return { ...state, events: action.payload };
    case DISMISS_FLASH_MESSAGE:
      return { ...state, flashMessage: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/profile/reducer.js